import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  userOverallReportRequest,
  userOverallReportSuccess,
  userOverallReportFailure,
} from '../reducers/userOverallReport';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* getUserReportAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;

  return yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/report`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );
}

function* workerGetUserReportSaga() {
  try {
    const response = yield call(getUserReportAxios);
    const responseFromGetUsersReport = response.data.data.reportData;
    switch (response.status) {
      case 200:
        yield put(userOverallReportSuccess(responseFromGetUsersReport));
        break;
      case 205:
      case 206:
      case 500:
        yield put(userOverallReportFailure(responseFromGetUsersReport));
        break;
      default:
        yield put(userOverallReportFailure(responseFromGetUsersReport));
    }
  } catch (error) {
    yield put(userOverallReportFailure(error));
  }
}

export function* watcherGetUserReportSaga() {
  yield takeLatest(userOverallReportRequest().type, workerGetUserReportSaga);
}
